import state from './state'
import mutation from './mutation'
import action from './action'

export default {
  state,
  mutation,
  action
}
